export const UserRole = Object.freeze({
    ADMIN: 'ADMIN',
    CLIENT: 'CLIENT',
    COLLABORATOR: 'COLLABORATOR'
})

export default UserRole;